module.exports = __webpack_public_path__ + "static/media/w3w_hover.016a557c.svg";